import React, { useMemo, useState } from 'react';

const FilterOptionSelect = ({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  searchPlaceholder,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOptions = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();
    if (!normalizedSearch) {
      return options;
    }

    return options.filter((option) =>
      `${option.label} ${option.value}`.toLowerCase().includes(normalizedSearch)
    );
  }, [options, searchTerm]);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        type="text"
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
        placeholder={searchPlaceholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
      />
      <select
        className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">{placeholder}</option>
        {filteredOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label} ({option.count.toLocaleString()})
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterOptionSelect;
